__turbopack_context__.v({
  "backdrop": "HG51wq_backdrop",
  "backdropFullHeightMobile": "HG51wq_backdropFullHeightMobile",
  "closeTrigger": "HG51wq_closeTrigger",
  "dialog": "HG51wq_dialog",
  "mobileFitContent": "HG51wq_mobileFitContent",
  "mobileFullWidth": "HG51wq_mobileFullWidth",
  "mobileFullscreen": "HG51wq_mobileFullscreen",
  "modalBody": "HG51wq_modalBody",
  "modalHeader": "HG51wq_modalHeader",
  "normal-dialog": "HG51wq_normal-dialog",
  "scrollWrapper": "HG51wq_scrollWrapper",
});
